import IndonesiaAmountForm from "./forms/IndonesiaAmountForm";
import IndonesiaPaymentDetailsForm from "./forms/IndonesiaPaymentDetailsForm";
import IndonesiaBeneficiaryForm from "./forms/IndonesiaBeneficiaryForm";
import IndonesiaWalletBeneficiaryForm from "./forms/IndonesiaWalletBeneficiaryForm";
import IndonesiaReviewForm from "./forms/IndonesiaReviewForm";
import { FormRegistryMap } from "../../shared/types";

export const indonesiaFormRegistry: FormRegistryMap = {
  amount: {
    bank: IndonesiaAmountForm,
    default: IndonesiaAmountForm,
  },
  payment: {
    bank: IndonesiaPaymentDetailsForm,
    default: IndonesiaPaymentDetailsForm,
  },
  beneficiary: {
    bank: IndonesiaBeneficiaryForm,
    wallet: IndonesiaWalletBeneficiaryForm,
    default: IndonesiaBeneficiaryForm,
  },
  review: {
    bank: IndonesiaReviewForm,
    default: IndonesiaReviewForm,
  },
};
